import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const SiteHomepageRedirectLoader: LoadableType<{
	children?: React.ReactNode;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SiteHomepageRedirect" */ '../src/SiteHomepageRedirect.tsx'
			)
		).SiteHomepageRedirect,
});
